import { NavLink, useNavigate } from 'react-router-dom';
import { DashboardIcon, PowerIcon, ScoreCardIcon, SolarPanelDatabaseIcon } from './AppIcons.jsx';
import { getSession } from '../utils/session.js';
import { signOutUser } from '../utils/storage.js';

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Dashboard', Icon: DashboardIcon },
  { to: '/score-card', label: 'Score Card', Icon: ScoreCardIcon },
  { to: '/solar-panels', label: 'Solar Panel Database', Icon: SolarPanelDatabaseIcon },
];

export default function SideRail() {
  const navigate = useNavigate();
  const session = getSession();

  async function signOut() {
    await signOutUser();
    navigate('/login', { replace: true });
  }

  return (
    <aside className="side-rail">
      <div className="side-rail__top">
        <div className="side-rail__brand-row">
          <div className="logo-mark" aria-label="N3bula logo">N3</div>
          <div>
            <div className="side-rail__brand">N3BULA STUDIO</div>
            <div className="side-rail__subtitle">Projects • Site Plan</div>
          </div>
        </div>

        <div className="side-rail__user-card">
          <div className="side-rail__avatar">{(session?.name || 'N3bula User').trim().charAt(0).toUpperCase()}</div>
          <div>
            <div className="side-rail__user-name">{session?.name || 'N3bula User'}</div>
            <div className="side-rail__user-role">Role: User</div>
          </div>
        </div>

        <nav className="side-rail__nav" aria-label="Main navigation" data-navigation-version="score-card-v3">
          {NAV_ITEMS.map(({ to, label, Icon }) => (
            <NavLink
              key={to}
              className={({ isActive }) => `side-rail__nav-link${isActive ? ' active' : ''}`}
              to={to}
            >
              <span className="side-rail__nav-icon">
                <Icon />
              </span>
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      <button className="text-btn danger side-rail__sign-out" type="button" onClick={signOut}>
        <span>Sign out</span>
        <PowerIcon />
      </button>
    </aside>
  );
}
